import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { StyledBackofficeMenu } from './style';

class BackofficeMenu extends Component {
	state = {
		showLinkUser: false,
		modify: false,
	}

	componentDidUpdate(prevProps, prevState) {
		const { user } = this.props;

		const { modify } = this.state;

		setTimeout(() => {
			if (user.data.relationships && !modify) {
				user.data.relationships.roles.map((userData) => {
					if (userData.name === 'admin') {
						return this.setState({
							showLinkUser: true,
							modify: true,
						});
					}

					return this.setState({
						modify: true,
					});
				});
			}

			return false;
		}, 1000);

		return (prevProps, prevState);
	}

	render() {
		const { showLinkUser } = this.state;

		if (!showLinkUser && !localStorage.getItem('showLinkUsuarios')) {
			return (
				<StyledBackofficeMenu className="cockpit-menu backoffice-menu">
					<ul className="cockpit-menu__list">
						<li className="cockpit-menu__item">
							<i className="fa fa-spinner fa-pulse" />
						</li>
					</ul>
				</StyledBackofficeMenu>
			);
		}

		const { user } = this.props;

		return (
			<StyledBackofficeMenu className="cockpit-menu backoffice-menu">
				<ul className="cockpit-menu__list">
					<li className="cockpit-menu__item">
						<Link to="/backoffice" className="cockpit-menu__link">
							<i className="fas fa-home icon mr-2" />
							Início
						</Link>
					</li>
					<li className="cockpit-menu__item">
						<Link to="/backoffice/demandas" className="cockpit-menu__link">
							<i className="fas fa-bullhorn icon mr-2" />
							Demandas
						</Link>
					</li>
					<li className="cockpit-menu__item">
						<Link to="/backoffice/clientes" className="cockpit-menu__link">
							<i className="fas fa-user-friends icon mr-2" />
							Clientes
						</Link>
					</li>

					{
						showLinkUser && localStorage.getItem('showLinkUsuarios') ? (
							<li className="cockpit-menu__item">
								<Link to="/backoffice/usuarios" className="cockpit-menu__link">
									<i className="fas fa-users-cog icon mr-2" />
									Usuários
								</Link>
							</li>
						) : null
					}

					<li className="cockpit-menu__item">
						<Link to="/backoffice/relatorios" className="cockpit-menu__link">
							<i className="fas fa-chart-bar icon mr-2" />
							Relatórios
						</Link>
					</li>

					<li className="cockpit-menu__item">
						<Link to="/backoffice/templates" className="cockpit-menu__link">
							<i className="fas fa-columns mr-2" />
							Templates
						</Link>
					</li>

					<li className="cockpit-menu__item">
						<Link to={`/backoffice/usuarios/${user.data ? user.data.id : 0}`} className="cockpit-menu__link">
							<i className="fas fa-cogs icon mr-2" />
							Configurações
						</Link>
					</li>
				</ul>
			</StyledBackofficeMenu>
		);
	}
}

const mapStateToProps = state => ({
	user: state.user,
});

export default connect(mapStateToProps)(BackofficeMenu);
